import React, { useState } from 'react'
import ReactModal from 'react-modal'
import { toast } from 'react-toastify';
import Spinner from '../spinner/spinnerSmall';
import './modals.scss'

ReactModal.setAppElement("#root")

export default function EditMainImageModal(props) {
    const [fileName, setFileName] = useState('*Upload Picture');
    const [currentFile, setCurrentFile] = useState('');
    const [fileChanged, setFileChanged] = useState(0)
    const [showLoader, setShowLoader] = useState(false)

    function onFileChange(event) {
        setFileName(event.target.files[0].name);
        setCurrentFile(event.target.files[0]);
        setFileChanged(fileChanged + 1)
    }

    function onSubmit() {
        if (!props.loading) {
            if (currentFile !== '' && fileChanged !== 0) {
                setShowLoader(true)
                props.editMainImage(currentFile, setShowLoader);
                // setShowLoader(false)
            } else {
                toast.error('Must change the image to update. Click "cancel" to exit.');
            }
        }
    }

    return (
        <ReactModal
            isOpen={props.isOpen}
            onRequestClose={() => props.handleModalClose()}
            style={{
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                width: '50%',
                height: '200px'
            }}

        >
            <div id="mainImageModal">
                <h2>Edit Main Product Image</h2>
                <label id="fileUploadButton">
                    <input type="file" accept="image/*" onChange={onFileChange} />
                    {fileName}
                </label>
                <div id="modalButtons">
                    {showLoader ? <Spinner /> : <div></div>}
                    <div id="cancelButton" onClick={props.handleModalClose}>Cancel</div>
                    <div id="updateButton" onClick={onSubmit}>Update</div>
                </div>
            </div>
        </ReactModal>
    )
}
